import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton'

const XSkeleton = ({ animation, classes, height, variant, width }) => {
  return <Skeleton animation={animation} classes={classes} height={height} variant={variant} width={width} />
}

export default XSkeleton
